import { TExportSelectedData } from './export-data';

export const xlsx_export_data: TExportSelectedData[] = [];
